import { defineStore } from 'pinia'
import Axios from 'axios'

const BASE_URL = process.env.VUE_APP_BASE_URL || window.location.origin + "/"
const PARAMETROS_URL = BASE_URL + "api/demandasrepetitivas/parametrolimitesuspensao"
export const useParametroLimiteSuspensaoStore = defineStore('parametroLimiteSuspensao', {
  state: () => ({ filtered: [], parametros: [] }),
  getters: {
    all: state => state.parametros,
  },
  actions: {
    async fetch() {
      const { data } = await Axios.get(PARAMETROS_URL)
      const { listaDeParametroLimiteSuspensao } = data
      this.filtered = this.parametros = listaDeParametroLimiteSuspensao
      return listaDeParametroLimiteSuspensao
    },
  },
})
